import AbstractRoute from './AbstractRoute';

export default class ProtectedRoute extends AbstractRoute {
    isAccessGranted(): boolean {
        return this.userDetailsNowLoading() || this.permissionsGranted() && this.hasAccessToken();
    }

    protected renderAccessDenied(): JSX.Element {
        if (this.hasAccessToken()) {
            return super.renderAccessDenied();
        }

        return this.renderRedirect();
    }

    protected hasAccessToken(): boolean {
        return this.context?.accessToken !== undefined;
    }

    protected userDetailsNowLoading(): boolean {
        return this.hasAccessToken() && this.context?.model === undefined;
    }
}
